import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyDotazioniService
 * Client API per registro dotazioni e armamento (armi, giubbotti, radio…).
 */
export default class SafetyDotazioniService {
    static getTipi = (id_azienda = "", id_lavoratore = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dotazioni/tipi`;
            const payload = {};
            if (id_azienda) payload.id_azienda = id_azienda;
            if (id_lavoratore) payload.id_lavoratore = id_lavoratore;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dotazioni/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static byLavoratore = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dotazioni/byLavoratore`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/dotazioni/create`;
        return ApiService.postFormData(url, formData);
    };

    static deleteDotazione = (id_dotazione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dotazioni/delete`;
            ApiService.postRequest(resolve, reject, url, { id_dotazione });
        });
    };

    static download = (id_dotazione, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dotazioni/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_dotazione, filename });
        });
    };
}
